module.exports = __webpack_public_path__ + "img/banner-dex-cards.65b35ffc.webp";